var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, createContext, useReducer } from "react";
;
var dispatchFn = function (state, action) {
    if (Array.isArray(action)) {
        return action.reduce(function (acc, curr) { return dispatchFnSwitch(acc, curr); }, __assign({}, state));
    }
    return dispatchFnSwitch(state, action);
};
var dispatchFnSwitch = function (state, action) {
    switch (action.type) {
        case "SET_UPDATES": {
            var updates = action.payload.updates;
            return __assign(__assign({}, state), { updates: updates });
        }
        default:
            return state;
    }
};
var defaultState = {
    updates: {},
};
var TableUpdateContext = createContext(__assign(__assign({}, defaultState), { dispatch: function () { return null; } }));
TableUpdateContext.displayName = "TableContext";
export var useTableUpdateContext = function () {
    return useContext(TableUpdateContext);
};
var TableUpdateDispatch = createContext(function () { return null; });
TableUpdateDispatch.displayName = "TableDispatch";
export var useTableUpdateDispatch = function () {
    return useContext(TableUpdateDispatch);
};
export var TableUpdateProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(dispatchFn, __assign({}, defaultState)), updates = _b[0].updates, dispatch = _b[1];
    return (React.createElement(TableUpdateDispatch.Provider, { value: dispatch },
        React.createElement(TableUpdateContext.Provider, { value: { updates: updates, dispatch: dispatch } }, children)));
};
